module.exports = __webpack_public_path__ + "static/media/Modelo1.2a3f7e52.png";